import React from 'react';
import { AppImage } from '../AppImage';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { Section } from '../Section';
import { pricingClosingImage } from '../../data/pricingImages';
export function PricingClosingImage() {
  return <Section bordered labelledBy="pricing-closing-caption" data-id="element-742" data-mp="2yuplnsu2toss">
      <Container data-id="element-743" data-mp="33wevx69h5yft">
        <Reveal data-id="element-744" data-mp="33vwwy1vfh647">
          <figure data-id="element-745" data-mp="33taps3cg8smi">
            <AppImage src={pricingClosingImage.image} alt={pricingClosingImage.alt} ratio="16:10" data-id="element-746" data-mp="3rlhgalvhu5e0" />
            <figcaption id="pricing-closing-caption" className="mt-4 text-[13px] leading-6 text-muted" data-id="element-747" data-mp="e55qpp48q72">
              {pricingClosingImage.caption}
            </figcaption>
          </figure>
        </Reveal>
      </Container>
    </Section>;
}